import React from 'react';
import { FaLock } from 'react-icons/fa';

// Permanent account-state notice, not a dismissible alert - the restriction stays
// until an admin reactivates the account, so hiding the banner would hide the reason.
const SuspendedBanner = () => (
  <div className="bg-amber-100 border-b border-amber-300 text-amber-900 px-4 py-3 text-sm">
    <div className="container mx-auto max-w-3xl flex items-start gap-2">
      <FaLock className="mt-0.5 flex-shrink-0 text-amber-600" />
      <p>
        <span className="font-semibold">Your account is suspended — read-only access.</span>{' '}
        You can view your jobs and download RCTIs, but you can't update jobs, submit quotes, or
        upload compliance documents. Contact your Jim's Mowing administrator to reactivate your
        account.
      </p>
    </div>
  </div>
);

export default SuspendedBanner;
